// the mapping of product details spec based on different product url
const { genProductSpecDetailUrl } = require('./urls');
const { dittoSymbol } = require('./static');

const URL_KEY = 'url';
exports.URL_KEY = URL_KEY;

const COMPLETE_URL_KEY = 'complete_url_key';
exports.COMPLETE_URL_KEY = COMPLETE_URL_KEY;

const NAME_KEY = 'name';
exports.NAME_KEY = NAME_KEY;

const getHeader = (data, { productUrl }) => {
    const header = {};
    const headerData = data[0];
    const headerExplainData = data[1];
    if (headerData.includes(NAME_KEY)) {
        headerData.forEach((value, index) => {
            if (value !== URL_KEY) {
                header[value] = headerExplainData[index];
            }
        });
        return header;
    }
    throw new Error(`${productUrl} is lack of ${NAME_KEY} header name`);
};
exports.getHeader = getHeader;

const getRow = (data, { categoryUrl, productUrl }) => {
    const rows = [];
    const headerData = data[0];
    for (let index = 2; index < data.length; index += 1) {
        const col = {};
        // Filter out the empty row, like: ,,,,,,
        let emptyRow = true;
        data[index].forEach((value, i) => {
            let cellValue = value;
            let isDitto = false;
            if (headerData[i] === URL_KEY) {
                if (cellValue) {
                    col[[COMPLETE_URL_KEY]] = { value: genProductSpecDetailUrl(categoryUrl, productUrl, cellValue) };
                }
            }
            if (headerData[i] === NAME_KEY && cellValue) {
                emptyRow = false;
            }
            if (cellValue === dittoSymbol) {
                let trackIndex = rows.length - 1;
                isDitto = true;
                while (true) {
                    if (!rows[trackIndex][headerData[i]].isDitto) {
                        rows[trackIndex][headerData[i]].rowSpan += 1;
                        cellValue = rows[trackIndex][headerData[i]].value;
                        break;
                    }
                    trackIndex -= 1;
                }
            }
            col[headerData[i]] = { value: cellValue, rowSpan: 1, isDitto };
        });
        if (!emptyRow) {
            rows.push(col);
        }
    }
    return rows;
};
exports.getRow = getRow;

exports.normalizeCSV = (data, { categoryUrl, productUrl }) => ({
    headers: getHeader(data, { productUrl }),
    rows: getRow(data, { categoryUrl, productUrl }),
});
